'use client';

export type PwaConfirmRequest = {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Destructive action (delete / leave) — red primary. */
  danger?: boolean;
};

type QueueItem = {
  request: PwaConfirmRequest;
  resolve: (ok: boolean) => void;
};

const queue: QueueItem[] = [];
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((fn) => fn());
}

export function getPwaConfirmCurrent(): PwaConfirmRequest | null {
  return queue[0]?.request ?? null;
}

export function subscribePwaConfirm(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function resolvePwaConfirm(ok: boolean) {
  const item = queue.shift();
  item?.resolve(ok);
  notify();
}

function normalizeRequest(input: string | PwaConfirmRequest): PwaConfirmRequest {
  if (typeof input === 'string') {
    return { title: input, confirmLabel: 'ОК', danger: true };
  }
  return {
    confirmLabel: 'ОК',
    cancelLabel: 'Отмена',
    danger: true,
    ...input,
  };
}

/** In-app confirm sheet. Replaces window.confirm in the PWA / APK. */
export function confirmPwa(input: string | PwaConfirmRequest): Promise<boolean> {
  if (typeof window === 'undefined') return Promise.resolve(false);
  return new Promise((resolve) => {
    queue.push({ request: normalizeRequest(input), resolve });
    notify();
  });
}
